import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';

import { TSegmentThumbnail } from '../types';

import { getSegmentThumbnails } from './get-segment-thumbnails';
import { videoThumbnailsQueryKeys } from './query-keys';

export function useGetMultipleSegmentThumbnails(
  segmentIds: string[]
): Record<string, TSegmentThumbnail[]> {
  const results = useQueries({
    queries: segmentIds.map(id => ({
      enabled: !!id,
      queryKey: videoThumbnailsQueryKeys.segmentThumbnails(id),
      queryFn: () => getSegmentThumbnails(id),
    })),
  });

  return useMemo(
    () =>
      segmentIds.reduce<Record<string, TSegmentThumbnail[]>>((acc, id, idx) => {
        const data = results[idx]?.data;
        if (data) acc[id] = data;
        return acc;
      }, {}),
    [segmentIds, results]
  );
}
